import React from "react";
// import { FieldFeedbackLabel } from "./FieldFeedbackLabel";
import { ToggleButton, ButtonGroup } from "react-bootstrap";
import { motion, AnimatePresence } from "framer-motion";
export function ToggleCheckbox({
    field, // { name, value, onChange, onBlur }
    form: { touched, errors, setFieldValue }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
    onChange,
    type = "checkbox",
    className = "",
    children,
    ...props
}) {
    const { value = "" } = field;
    return (
        <AnimatePresence>
            <div className="d-flex flex-column">
                <ButtonGroup toggle>
                    <ToggleButton type={type}  {...field} {...props} checked={value} className={`btn-outline-primary ${className}`}>
                        <div className="d-flex flex-row justify-content-center">
                            <div className="d-flex align-items-baseline w-20px">
                                {value ? (<motion.i
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }}
                                    exit={{ opacity: 0 }}
                                    className="fa fa-check text-success label label-light p-4"></motion.i>) : (<>{" "}</>)}
                            </div>
                            <div className="w-100">
                                {children}
                            </div>
                        </div>

                    </ToggleButton>
                </ButtonGroup>
            </div>
        </AnimatePresence>

    );
}
